export interface Sortable {
  ordinal?: number;
}

export const sortData = <TData extends Sortable>(data: TData[]) => {
  return [...data].sort(
    (first, last) => (first.ordinal ?? Infinity) - (last.ordinal ?? Infinity),
  );
};
